import { PatientReferenceIdentifier } from '@dreryk/egabinet-patient-published-language-api';

import { createTranslatedText, TranslatableText } from '@dreryk/react-common';

export const getPatientReferenceIdentifierValueTranslatableText = (
   referenceIdentifier: PatientReferenceIdentifier | undefined
): TranslatableText => {
   if (!referenceIdentifier) {
      return createTranslatedText('-');
   }

   const externalIdentifier = referenceIdentifier.findExternalIdentifier();
   if (externalIdentifier) {
      return createTranslatedText(
         externalIdentifier.accept({
            visitPesel: (pesel) => pesel.asString(),
            visitGuardianPesel: (guardianPesel) => guardianPesel.asString(),
            visitPassport: (passport) => passport.getValue(),
            visitNationalIdentificationNumber: (nationalIdentificationNumber) =>
               nationalIdentificationNumber.getValue(),
         })
      );
   }
   const medicalRecordNumber = referenceIdentifier.findMedicalRecordNumber();
   if (medicalRecordNumber) {
      return createTranslatedText(medicalRecordNumber.asString());
   }

   return createTranslatedText('-');
};
